module.exports = __webpack_public_path__ + "img/qrBtn.d5be4ddc.png";